import { Component, ElementRef, Input, OnChanges } from '@angular/core';
import { SvgIconName, SvgIconService } from '@client/app/shared-modules/svg-icons/services/svg-icon.service';

@Component({
    selector: 'mon-svg-icon',
    standalone: true,
    template: '',
    host: { '[class]': 'iconClass' },
})
export class SvgIconComponent implements OnChanges {
    @Input({ required: true }) name!: SvgIconName;
    @Input() iconClass = 'material-symbol-svg';

    constructor (
        private readonly iconService: SvgIconService,
        private readonly elementRef: ElementRef<HTMLElement>,
    ) {}

    ngOnChanges (): void {
        const host = this.elementRef.nativeElement;
        host.textContent = '';

        const svgString = this.iconService.getIconSvg(this.name);
        const parsed = new DOMParser().parseFromString(svgString, 'image/svg+xml');
        const svgElement = parsed.documentElement;

        if (svgElement instanceof SVGSVGElement) {
            host.appendChild(svgElement);
        }
    }
}
